export enum AuthProviderName {
    PUBLICIS = 'publicis'
}